import {z} from '@hono/zod-openapi';

import {amount} from './amount';

/** Current, precomputed Metada classifications for one stock card. */
export const ArticleAbcXyzSchema = z
  .object({
    abcClass: z.string().nullable(),
    xyzClass: z.string().nullable(),
    combinedClass: z.string().nullable(),
    netConsumptionValue: amount.nullable(),
    sharePercent: amount.nullable(),
    cumulativeSharePercent: amount.nullable(),
    abcRank: z.number().int().nullable(),
    abcHistoryMonthCount: z.number().int().nullable(),
    abcPeriodStart: z.string().date().nullable(),
    abcPeriodEnd: z.string().date().nullable(),
    abcSnapshotDate: z.string().date().nullable(),
    meanMonthlyQuantity: amount.nullable(),
    coefficientOfVariation: amount.nullable(),
    seasonalityCorrelation: amount.nullable(),
    activeMonthCount: z.number().int().nullable(),
    xyzHistoryMonthCount: z.number().int().nullable(),
    xyzResultStatus: z.string().nullable(),
    xyzPeriodStart: z.string().date().nullable(),
    xyzPeriodEnd: z.string().date().nullable(),
    xyzSnapshotDate: z.string().date().nullable(),
  })
  .openapi('ArticleAbcXyz');

export type ArticleAbcXyz = z.infer<typeof ArticleAbcXyzSchema>;
